import type { ComponentType, ReactNode } from 'react';
import {
  type LoaderFunction,
  type ShouldRevalidateFunction,
} from 'react-router';

import type { HorizonLoaderFunction } from 'routing/types/HorizonLoaderFunction';
import type { HorizonLoaderFunctionData } from 'routing/types/HorizonLoaderFunctionData';
import type { HorizonRouteComponentProps } from 'routing/types/HorizonRouteComponentProps';

import { renderLoader } from './renderLoader/renderLoader';

export function horizonRouteToObject<
  TLoader extends HorizonLoaderFunction,
>(exportedValues: {
  id?: string;
  handle?: Record<string, unknown>;
  shouldRevalidate?: ShouldRevalidateFunction;
  loader?: TLoader;
  default: ComponentType<HorizonRouteComponentProps<TLoader>>;
}): {
  id?: string;
  handle?: Record<string, unknown>;
  shouldRevalidate?: ShouldRevalidateFunction;
  loader: LoaderFunction;
  element: ReactNode;
} {
  const {
    id,
    handle,
    shouldRevalidate,
    loader,
    default: Component,
  } = exportedValues;

  return {
    id,
    handle,
    shouldRevalidate,
    ...renderLoader({
      loader: (loader || (() => null)) as LoaderFunction,
      render: (loaderData, params) => (
        <Component
          loaderData={loaderData as HorizonLoaderFunctionData<TLoader>}
          params={params}
        />
      ),
    }),
  } as const;
}
